export const ADD_PERMISSION = "ADD_PERMISSION"
export const GET_PERMISSION = "GET_PERMISSION"
export const ALL_PERMISSION = "ALL_PERMISSION"
export const EDIT_PERMISSION = "EDIT_PERMISSION"
